module.exports = __webpack_public_path__ + "img/move09.7b772a9e.jpg";